/**
 * `knowledge_chunks.source_id` uuid, de az összesítő chunkoknak (havi kiadás,
 * fázis-szintű bontás) nincs saját sora a DB-ben. Kulcsból származtatott,
 * ismétlésre azonos uuid kell, hogy az újraindexelés cserélni tudja őket.
 */
function mix(input: string, seed: number): number {
  let h = seed >>> 0;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  h ^= h >>> 16;
  h = Math.imul(h, 0x85ebca6b) >>> 0;
  h ^= h >>> 13;
  h = Math.imul(h, 0xc2b2ae35) >>> 0;
  h ^= h >>> 16;
  return h >>> 0;
}

const SEEDS = [0x811c9dc5, 0x01000193, 0x9e3779b9, 0x7feb352d];

export function stableUuidFromKey(key: string): string {
  const bytes = new Uint8Array(16);
  SEEDS.forEach((seed, block) => {
    const h = mix(key, seed);
    bytes[block * 4 + 0] = (h >>> 24) & 0xff;
    bytes[block * 4 + 1] = (h >>> 16) & 0xff;
    bytes[block * 4 + 2] = (h >>> 8) & 0xff;
    bytes[block * 4 + 3] = h & 0xff;
  });
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x50;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20, 32)
  ].join("-");
}
